import { CircularProgress, Container } from "@mui/material";
import React from "react";

export const Loader = () => (
  <Container
    sx={{
      marginTop: 2,
      textAlign: "center",
    }}
  >
    <CircularProgress />
  </Container>
);
